var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddForecastDialog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 0.75H0V18.25H20V4.5H2.5V3.25H18.75V0.75ZM16.25 12.625C15.5469 12.625 15 12.0781 15 11.375C15 10.7109 15.5469 10.125 16.25 10.125C16.9141 10.125 17.5 10.7109 17.5 11.375C17.5 12.0781 16.9141 12.625 16.25 12.625Z",
    fill: "#98BCD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddForecastDialog);
export default __webpack_public_path__ + "static/media/add_forecast_dialog.8fb297d82340ac365e54f7aae2b4832b.svg";
export { ForwardRef as ReactComponent };